module.exports = __webpack_public_path__ + "static/media/coperta33.fcdb864a.jpg";